import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Google
 * id 723F4461-61B3-4D53-A03D-302F5D9401E1
 * name format-vertical-align-bottom
 * version: 1.6.50
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/format-vertical-align-bottom.svg
 * tags
 * - Text / Content / Format 
 */
export const FormatVerticalAlignBottomIcon = createSvgIcon(<><path d="M16,13H13V3H11V13H8L12,17L16,13M4,19V21H20V19H4Z" /></>, 'FormatVerticalAlignBottomIcon');
export default FormatVerticalAlignBottomIcon